import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

function useQuery() {
  const location = useLocation();
  const [queryParams, setQueryParams] = useState(new URLSearchParams(location.search));

  useEffect(() => {
    setQueryParams(new URLSearchParams(location.search));
  }, [location.search]);

  return queryParams;
}

export default useQuery;